import Alpine from "alpinejs";
import htmx from "htmx.org";
import officeState from "./state";

async function onActivateTermLynx() {
  try {
    const addin = Office.addin as any; // { _getState: () => Promise<string> };
    const state = await addin._getState();
    if (state == "Visible") {
      const p = Office.addin.hide().then(() => Office.addin.showAsTaskpane());
      const box = document.querySelector<HTMLInputElement>(
        'input[type="search"]'
      );
      if (box !== null) {
        box.blur();
        box.value = "";
        box.focus();
        htmx.trigger(box, "changed", {});
      }
      await p;
    } else {
      await Office.addin.showAsTaskpane();
    }
  } catch (error) {
    console.error("Failed to get addin state:", error);
  }
}

Alpine.effect(() => {
  if (officeState.loaded && officeState.enabled) {
    Office.actions.getShortcuts().then((shortcuts) => {
      if (Object.keys(shortcuts).length == 0) {
        //TODO: remove
        //console.error("no shortcuts found");
      }
      for (const action in shortcuts) {
        let shortcut = shortcuts[action];
        console.info(`Shortcut: ${action}: ${shortcut}`);
      }
    });
    Office.actions.associate("ActivateTermLynx", async () => {
      await onActivateTermLynx();
    });
  }
});
